import { BusinessIncome } from '@/app/business-income/entities/business-income.entity'

export interface BusinessIncomeState {
    businessIncomes: BusinessIncome[]
}

export const state: BusinessIncomeState = {
    businessIncomes: []
}
